// extracted by mini-css-extract-plugin
export default {"mainContents":"ComingSoon_mainContents__pmqzm"};